module.exports = __webpack_public_path__ + "static/photo3-c321addc0773ea761a0cbdc9b9c9d506.jpg";